var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-input',{ref:"input",class:("text-area " + (_vm.required ? '--required' : '') + " " + (_vm.disabled ? 'input--disabled' : '') + " "),attrs:{"rules":_vm.rules,"disabled":_vm.disabled,"readonly":_vm.readonly,"error-messages":_vm.errorMessages,"label":_vm.label,"light":""},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},[_c('textarea',{attrs:{"autocomplete":_vm.type === 'password' ? 'off' : 'on',"type":_vm.type,"rows":_vm.rows,"cols":_vm.cols},domProps:{"value":_vm.value},on:{"input":function (e) {
        _vm.$emit('input', e.target.value);
      },"change":function (e) {
        _vm.$emit('change', e.target.value);
      },"blur":function (e) {
        _vm.$emit('blur', e.target.value);
      }}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e28603f6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/fields/TextArea.vue
// module id = null
// module chunks = 